// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.
// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener('cart:item-added', function (evt) {
//   console.log('Item added to the cart');
//   console.log(evt.detail.product);
}); // This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('cart:updated', function (evt) {
//   console.log('Cart updated');
//   console.log(evt.detail.cart);
  $('.quick-cart__item-middle div:first-of-type').hide();
  $('.quick-cart__total span.fs-body-bold').hide();
  $.ajax({
      type: 'GET',
      url: '/cart?view=metafields.json',
      success: function(response) {
          json_response = JSON.parse(response);
          sideCartWC(evt.detail.cart.items, json_response);
      },
      error: function(status) {
          console.warn( 'ERROR', status );
      }
  })
  $('.quick-cart__item-middle div:first-of-type').fadeIn(3000);
  $('.quick-cart__total span.fs-body-bold').fadeIn(3000);
  //Sidecart Volume Discounts
  setTimeout(function() {
    updateCartItems(hulkapps.discounts.cart.items, hulkapps.discounts.discounted_price_total);
  }, 1000); // Delay for 2000 milliseconds (2 seconds)

}); // This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.

document.addEventListener('cart:error', function (evt) {
  console.log('Cart error');
  console.log(evt.detail.errorMessage);
}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.

document.addEventListener('quick-cart:open', function (evt) {
//   console.log('Quick cart opened');
//   console.log(evt.detail.cart);
  	$('.quick-cart__item-middle div:first-of-type').hide();
  	$('.quick-cart__total span.fs-body-bold').hide();
    $.ajax({
      type: 'GET',
      url: '/cart?view=metafields.json',
      success: function(response) {
          json_response = JSON.parse(response);
          sideCartWC(evt.detail.cart.items, json_response);
      },
      error: function(status) {
          console.warn( 'ERROR', status );
      }
  })
  $('.quick-cart__item-middle div:first-of-type').fadeIn(3000);
  $('.quick-cart__total span.fs-body-bold').fadeIn(3000);
  //Sidecart Volume Discounts
  setTimeout(function() {
    updateCartItems(hulkapps.discounts.cart.items, hulkapps.discounts.discounted_price_total);
  }, 1000); // Delay for 2000 milliseconds (2 seconds)

}); // This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.

document.addEventListener('quick-cart:close', function () {
  console.log('Quick cart closed');
}); // This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.

document.addEventListener('product:variant-change', function (evt) {
  // console.log('Product variant changed');
  // console.log(evt.detail.variant);

          // Afterpay
          var afterpayPriceContainer = $('.afterpay'); // Define Afterpay Price Container
          var priceContainer = $('.product__top span.main-price')[0].innerText; // Define Pricing Container
          var priceStrip = priceContainer.replace('$','')
      
          var apPrice = round((+priceStrip / 4),2); // Afterpay Price
          
          afterpayPriceContainer.text('$' + apPrice + ' AUD');

  wholesaleVariantChanged(evt.detail.variant);

          // Afterpay
          var afterpayPriceContainer = $('.afterpay'); // Define Afterpay Price Container
          var priceContainer = $('.product__top span.main-price')[0].innerText; // Define Pricing Container
          var priceStrip = priceContainer.replace('$','')
      
          var apPrice = round((+priceStrip / 4),2); // Afterpay Price
          
          afterpayPriceContainer.text('$' + apPrice + ' AUD');
  
}); // This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.

document.addEventListener('product:quantity-update', function (evt) {
  // console.log('Product quantity updated');
  // console.log(evt.detail.quantity, evt.detail.variant);
});

function sideCartWC(variants, metafields) {
  	
  	var total = [];
  
  	for(var i = 0; i < variants.length; i++) {
      var id = variants[i].id;
      var qty = variants[i].quantity;
      var rePrice = variants[i].final_line_price / 100;
      
      var priceContainer = document.querySelector(`.quick-cart__item[data-id="${id}"] .quick-cart__item-middle div:first-of-type`);
	  var totalContainer = document.querySelector('.quick-cart__total span.fs-body-bold');	
      
      if(metafields[id].tags.includes('Wholesale') && metafields[id].metafield1 > 0) {
        var price = metafields[id].metafield1;
        total.push(price * qty);
      	priceContainer.innerHTML = "$" + round(metafields[id].metafield1,2) + `<span class='c-subdued'> x ${qty}</span>`;
      } else if(metafields[id].tags.includes('Exporter') && metafields[id].metafield2 > 0) {
      	var price = metafields[id].metafield2;
        total.push(price * qty);
      	priceContainer.innerHTML = "$" + round(metafields[id].metafield2,2) + `<span class='c-subdued'> x ${qty}</span>`;
      } else if(metafields[id].tags.includes('Distributor') && metafields[id].metafield3 > 0) {
      	var price = metafields[id].metafield3;
        total.push(price * qty);
      	priceContainer.innerHTML = "$" + round(metafields[id].metafield3,2) + `<span class='c-subdued'> x ${qty}</span>`;
      } else if (metafields[id].tags.includes('Wholesale') && metafields[id].metafield1 === 0 || metafields[id].tags.includes('Exporter') && metafields[id].metafield2 === 0 || metafields[id].tags.includes('Distributor') && metafields[id].metafield3 === 0) {
      	total.push(rePrice)
      }
	}
  	totalContainer.innerText = "$" + round(total.reduce((pre,curr)=>pre+curr,0),2);
}

function round(value, decimals) {
    return Number(Math.round(value +'e'+ decimals) +'e-'+ decimals).toFixed(decimals);
}